import Col from './col';
import useInternalBreakpoint from './hooks/useBreakpoint';
import Row from './row';
// Do not export params
function useBreakpoint() {
  return useInternalBreakpoint();
}
export { Row, Col };
export default {
  useBreakpoint: useBreakpoint
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/grid/index.js
// module id = 266
// module chunks = 1